<template>    
<div class="card border-0 mt-xl-5">
  <div class="card-body">

    <div class="row">
      <div class="col-12">

        <div v-if="loadingContact == 0" class="row">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <scaling-squares-spinner :animation-duration="2000" :size="45" color="#0E1698" style=""/>
            <span class="ml-3 h6" style="color:#0E1698">Loading Contact...</span>
          </div>
        </div>

        <div v-if="loadingContact == 1" class="row">
          <div class="col-12 mb-2">
            <span class="text-muted">Name: </span>{{ contactDetails.fullName }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">Email: </span>{{ contactDetails.pri_email }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">Phone: </span>{{ contactDetails.pri_phone }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">Created: </span>{{ contactDetails.created_at | moment("dddd, MMMM Do YYYY") }}
          </div>
          <div class="col-12 mb-2">
            <span class="text-muted">Created By: </span>{{ contactDetails.creatorName }}
          </div>
          <div class="col-12 mb-4">
            <span class="text-muted">Last Modified: </span>{{ contactDetails.updated_at | moment("dddd, MMMM Do YYYY") }}
          </div>
          <div class="col-12">
            <button @click="cancelView" class="btn btn-primary">Close</button>
            <button @click="editContact" class="btn btn-warning">Edit</button>
          </div>
        </div>

      </div>

    </div>

  </div>
</div>
</template>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../../stores/settings-user-main-store.js'

export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      contactDetails: [],
      loadingContact: 0,
    }
  },
  computed: {

  },
  watch: {
    prop1() { this.getContactDetails(); },
    
  },
  mounted() {
    this.getContactDetails();
  },
  methods: {
    getContactDetails(){
      var _this = this;
      _this.loadingContact = 0
      axios.get('/utility/user/contact/getspecificcontact/' + _this.prop1)
        .then(function (response) {
          var a = response.data.data;
          _this.contactDetails = a;
          _this.loadingContact = 1;
        });
    },
    cancelView() {
      var _this = this;
      _this.$emit('onUComplete', [ 'contact-view' ])
    },
    editContact() {
      var _this = this;
      _this.$emit('onSecondary', [ 'contact-view', _this.contactDetails.id ])
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    ScalingSquaresSpinner,
  },
  filters: {

  }
}
</script>
